module.exports = __webpack_public_path__ + "img/2.365487d0.jpg";